import React from 'react';
import { getTypeOfPeriodName } from 'reactApp/utils/Period';

import styles from './PersonalDiscountPrice.css';

interface PersonalDiscountPriceProps {
    period: string;
    oldPrice?: number;
    newPrice: number;
}

export function PersonalDiscountBanner() {
    return <div className={styles.discount}>скидка</div>;
}

export function PersonalDiscountPrice({ newPrice, period, oldPrice }: PersonalDiscountPriceProps) {
    return (
        <div className={styles.root}>
            <div className={styles.priceContainer}>
                {oldPrice ? <span className={styles.crossedText}>{oldPrice} ₽</span> : null}
                <span className={styles.priceContainer}>
                    {newPrice} ₽ в {getTypeOfPeriodName(period)}
                </span>
            </div>
            <PersonalDiscountBanner />
        </div>
    );
}
